/**
 * 其知创新 合作伙伴
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/index/index' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>合作伙伴</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.title" style="width:140px" placeholder="请输入姓名"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="title" align="center" label="标题" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="imageUrl" align="center" label="图片" width="300" show-overflow-tooltip>
        <template slot-scope="scope">
            <img :src="scope.row.imageUrl" style="width: 160px;height: 90px;"></img>
        </template>
      </el-table-column>
      <el-table-column prop="desc" align="center" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sort" align="center" label="排序值" width="60" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delNew(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="addTitle" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" ref="editForm" :model="editForm" :rules="addFormRules">
        <el-row>
            <el-col :span="12" >
                <el-form-item label="标题" prop="title">
                    <el-input size="small" v-model="editForm.title" auto-complete="off" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="desc">
                    <el-input size="small" type="textarea" v-model="editForm.desc" auto-complete="off" placeholder="请输入备注" clearable></el-input>
                </el-form-item>
                <el-form-item label="排序值" prop="sort">
                    <el-input size="small" v-model="editForm.sort" auto-complete="off" placeholder="请输入排序值" clearable></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 185px;">
                <el-form-item label="图片" prop="image">
                    <el-upload class="avatar-uploader"
                            :action=uploadImage
                            :headers=setHeader
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item style="margin-top: 10px;">
            <el-button size="mini" type="primary" @click="submitEditNews('editForm')">提交</el-button>
            <el-button size="mini" @click='closeDialog("editForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { 
    officeDataList,
    officeDataEdit,
    officeDataDel
} from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'

// const apiUrl = "http://192.168.0.158/index.php";
const apiUrl = "https://zlbb.qzhip.com/index.php";
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {

      idShow: false,
      idCoverShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      dialogVisible: false, //控制预览图片显示与隐藏
      isVideo: false,
      isProvince: false,

      selectedOptions: [],
      title: '详情',
      addTitle: '发布',
      multipleSelection: [],
      editForm: {
        id: '',
        title: '',
        image: '',
        desc: '',
        type: 3,
        sort: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        title: '',
        type: 3,
      },
      imageUrl: '',
      setHeader: {
        'token': localStorage.getItem('logintoken')
      },
      uploadImage: apiUrl + "/admin/article/uploadImage",
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      addFormRules: {
        title: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请上传照片', trigger: 'blur' }
        ],
        desc: [
          { required: true, message: '请输入简介', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ]
      },

    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       officeDataList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示编辑界面
    handleEdit: function(index, row){
      if (row) {
        this.addTitle = '编辑'
        this.editForm.id = row.id,
        this.editForm.title = row.title,
        this.editForm.image = row.image,
        this.editForm.desc = row.desc,
        this.editForm.sort = row.sort,
        this.imageUrl = row.imageUrl
      } else {
        this.addTitle = '添加'
        this.isProvince = false
        this.editForm.id = '',
        this.editForm.title = '',
        this.editForm.image = '',
        this.editForm.desc = '',
        this.editForm.sort = '',
        this.imageUrl = ''
      }
      this.editFormVisible = true
    },
    // 编辑页面保存方法
    submitEditNews(editData) {
      //校验参数
      this.$refs[editData].validate(valid => {
        if(valid){
           officeDataEdit(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '发布成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        }else{
          return false;
        }
      })
    },
    // 删除文章
    delNew(index, row) {
    // 添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
      const delParam = {id:row.id}
      officeDataDel(delParam)
      .then(res=>{
        this.loading = false
        console.log(res);
        res = checkLogin(res)
        if (res.code == 200) {
            this.$message({
                type: 'success',
                message: '删除成功'
          })
            this.getdata(this.formInline)
        } else {
            this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 图片上传相关开始
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.editForm.image = res.data.save_url
          this.imageUrl = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },
    // 图片上传结束
  }
  }
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader>>>.el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 218px;
  height: 158px;
  line-height: 158px;
  text-align: center;
}
.avatar {
  width: 218px;
  height: 158px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/office/Partner.vue